// © Microsoft Corporation. All rights reserved.
// IF YOU UPDATE THIS FILE PLEASE UPDATE THE ONE IN @msnews/core
// DUE TO TREE SHAKING ISSUES WHEN IN DEBUG WE CAN'T USE COMMON CODE
// WITHOUT CAUSING ISSUES IN WebWorker
/** Helper class to work on URL search params */
export class UrlSearchParamsHelper {
    constructor(search) {
        /** Object that contains all the query strings */
        this.searchParams = Object.create(null);
        this.parseQueryString(search);
        return this;
    }
    /**
     * Sets the query string value
     * @param name query string name
     * @param value query string value
     */
    set(name, value) {
        if (value !== undefined && value !== null) {
            this.searchParams[name] = value;
        }
        return this;
    }
    /**
     * Gets the query string value
     * @param name query string name
     */
    get(name) {
        return this.searchParams[name];
    }
    /**
     * Deletes the query string value
     * @param name query string name
     */
    delete(name) {
        delete this.searchParams[name];
    }
    /**
     * Get all the query string params
     * @returns all query string params
     */
    getSearchParams() {
        return this.searchParams;
    }
    /**
     * Returns the query parameters as a string
     */
    toString() {
        const keys = Object.keys(this.searchParams);
        if (!keys.length) {
            return "";
        }
        return keys.sort().map((key) => {
            return `${key}=${this.searchParams[key]}`;
        }).join("&");
    }
    /** Parses the query string and adds the values to searchParams */
    parseQueryString(queryString) {
        if (!queryString) {
            return;
        }
        if (queryString.charAt(0) === "?") {
            queryString = queryString.substring(1);
        }
        queryString.split("&").forEach((keyValuePairs) => {
            const query = keyValuePairs.split("=");
            const name = query[0];
            if (!this.get(name)) {
                this.searchParams[name] = query[1];
            }
        });
    }
}
//# sourceMappingURL=UrlSearchParamsHelper.js.map